import React from "react";
import firebase from "./firebase/firebase";
import { useAsync } from "react-async";
import Moment from "react-moment";
import { BsTrash } from "react-icons/bs";
import { updateLikes, deletePost, createPost } from "./dao/post";

class MainPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      errorMsg: "",
      likes: 0,
      newPost: "",
      loading: false,
      currentUserId: this.props.appProps.state.userid,
      btnPostDisable: false,
    };

    console.log("mainpage this ", this);
    this.onChange = this.onChange.bind(this);
    this.onLikeClick = this.onLikeClick.bind(this);
    this.createPost = this.createPost.bind(this);
    this.onRefresh = this.onRefresh.bind(this);
  }

  handleState = (name, val) => {
    this.setState({
      [name]: val,
    });
  };

  onRefresh(event) {
    console.log("on user chnage");
    const { value } = event.target;
    this.getMessages(this.props.appProps.state.userid);
  }

  onChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  onLikeClick(keyid, userid) {
    const items = this.props.mainCtrlProps.state.messages; //this.state.messages;
    const item = items.find(
      (item) => item.keyid === keyid && item.userid === userid
    );

    item.likes = item.likes + 1;
    //this.updateLikes(keyid, userid, item.likes);
    updateLikes(keyid, userid, item.likes);
    this.props.mainCtrlProps.handleState("messages", items);
  }

  // updateLikes(keyid, userid, nLikes) {
  //   const fs = firebase.firestore();
  //   const posts = fs.collection("Posts").doc(userid);
  //   const msg = posts
  //     .collection("Messages")
  //     .doc(keyid)
  //     .update({ likes: nLikes })
  //     .then(() => {
  //       console.log("successfully updated likes ");
  //     })
  //     .catch((error) => {
  //       console.log("error on like", error);
  //     });
  // }

  delPost(keyid, userid) {
    deletePost(keyid, userid, this.props.mainCtrlProps);
    // const fs = firebase.firestore();
    // const posts = fs.collection("Posts").doc(userid);
    // const msg = posts
    //   .collection("Messages")
    //   .doc(keyid)
    //   .delete()
    //   .then(() => {
    // console.log("successfully deleted post ");
    // const items = this.props.mainCtrlProps.state.messages; //this.state.messages;
    // const index = items.findIndex(
    //   (item, i) => item.keyid === keyid && item.userid === userid
    // );
    // delete items[index];
    // this.props.mainCtrlProps.handleState("messages", items);
    // })
    // .catch((error) => {
    //   console.log("error on delete", error);
    // });
  }

  createPost(event) {
    if (this.state.newPost.trim() === "") {
      this.setState({
        btnPostDisable: true,
      });
      let val = this.state.newPost.trim();
      this.setState({
        newPost: val,
      });
      return;
    }

    // if (this.state.newPost.trim() != "") {
    //   this.setState({
    //     btnPostDisable: false,
    //   });
    // }
    createPost(
      this.props.appProps.state.userid,
      this.props.mainCtrlProps,
      this
    );
    // .then((post) => {
    //   console.log("msg posted", post);
    //   //console.log("added a new post ", doc.id);
    //   let items = this.props.mainCtrlProps.state.messages;
    //   //items.push({ userid: uid, keyid: doc.id, ...newPost });
    //   items.push(post);
    //   this.setState({ newPost: "", btnPostDisable: false });
    //   this.props.mainCtrlProps.handleState("messages", items);
    // })
    // .catch((error) => {
    //   console.log("error on creating post for doc id", error);
    //   this.setState({ btnPostDisable: false });
    //});

    this.setState({
      btnPostDisable: false,
      newPost: "",
    });

    // const dt = new firebase.firestore.Timestamp.fromDate(new Date());
    // const newPost = {
    //   message: this.state.newPost,
    //   likes: 0,
    //   datecreated: dt,
    // };

    // const fs = firebase.firestore();
    // const uid = this.props.appProps.state.userid;
    // const posts = fs.collection("Posts").doc(uid);
    // const msg = posts.collection("Messages");
    // const id = "";
    // msg
    //   .add({ id })
    //   .then((doc) => {
    //     msg
    //       .doc(doc.id)
    //       .set(newPost)
    //       .then(() => {
    //         console.log("added a new post ", doc.id);
    //         let items = this.props.mainCtrlProps.state.messages;
    //         items.push({ userid: uid, keyid: doc.id, ...newPost });
    //         this.setState({ newPost: "", btnPostDisable: false });
    //         this.props.mainCtrlProps.handleState("messages", items);
    //       })
    //       .catch((error) => {
    //         console.log("error on creating post for doc id", error);
    //         this.setState({ btnPostDisable: false });
    //       });
    //   })
    //   .catch((error) => {
    //     console.log("error in creating post", error);
    //     this.setState({ btnPostDisable: false });
    //   });
  }

  render() {
    let { username } = this.props.appProps.state;
    let messages = this.props.mainCtrlProps.state.messages;
    let { displayPost, loading } = this.props.mainCtrlProps.state;
    let follower = this.props.mainCtrlProps.state.follower;
    let following = this.props.mainCtrlProps.state.following;
    //let { follower, following } = this.props.mainCtrlProps.state;

    return (
      <div>
        <h3>{username}</h3>
        <div className="row">
          <div className="col text-center">
            <h2>
              {following} <h6>following</h6>
            </h2>
          </div>
          <div className="col text-center">
            <h2>
              {follower} <h6>followers</h6>
            </h2>
          </div>
        </div>

        {/** POST TEXT BOX */}
        <div class="input-group mb-3" style={{ display: displayPost }}>
          <textarea
            class="form-control shadow-none"
            placeholder="Share thoughts to your friends & the world..."
            name="newPost"
            value={this.state.newPost}
            onChange={this.onChange}
          ></textarea>
          <div class="input-group-append">
            <button
              class="btn btn-secondary shadow-none"
              onClick={this.createPost}
              disabled={this.state.btnPostDisable}
            >
              Post
            </button>
          </div>
        </div>

        {/* * User posts/messages*/}

        {this.state.error ? (
          <div class="alert alert-danger text-center">
            <strong>Error!</strong> {this.state.errorMsg}
            &nbsp;&nbsp;
            <button
              type="button"
              class="btn btn-secondary"
              onClick={this.getMessages}
            >
              <i class="fa fa-home"></i>
            </button>
          </div>
        ) : (
          <div></div>
        )}
        {/** User post layout */}

        {!loading ? (
          messages.length === 0 ? (
            <div className="text-center">
              <h2>You have no posts</h2>
              <small>
                <em>
                  Share your first post but adding a message to the post bar
                  above!
                </em>
              </small>
            </div>
          ) : (
            messages
              .sort((a, b) => (a.datecreated > b.datecreated ? -1 : 1))
              .map((msg) => (
                <div class="card">
                  <div class="card-header">{username}</div>
                  <div class="card-body">
                    <div>
                      <h6>
                        <i
                          className="far fa-heart pointer"
                          onClick={() =>
                            this.onLikeClick(msg.keyid, msg.userid)
                          }
                        ></i>
                        &nbsp;&nbsp;{msg.likes}
                      </h6>
                    </div>
                    <p>{msg.message}</p>
                    <br />
                    <br />
                    <div className="row">
                      <div className="col ">
                        <small>
                          <em>
                            <Moment format="MMM DD, YYYY hh:mm A">
                              {msg.datecreated.toDate().toString()}
                            </Moment>
                          </em>
                        </small>
                      </div>
                      <div className="col text-right align-text-top">
                        <BsTrash
                          style={{ display: displayPost }}
                          className="pointer"
                          onClick={() => this.delPost(msg.keyid, msg.userid)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))
          )
        ) : (
          <div></div>
        )}
        <div>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
        </div>
      </div>
    );
  }
}

export default MainPage;
